/**Packages */
import axios from "axios";

/**Helpers */
import { ALLOWED_METHODS, DEFAULT_LANGUAGE, STATUS_CODE_TEXT, MESSAGE_GENERIC_ERROR } from "./helpers/constants";
import { isIncludedInArray } from "./helpers/utils";
import { createSuccessResponse, createErrorResponse } from "./helpers/response";

const defaultCallback200 = (data) => {
  //BASE CASE -> when not specified
  if (typeof alert !== "undefined") {
    alert(data && data.data ? data.data : data.toString());
  }
};
const defaultCallback400 = (error, language = DEFAULT_LANGUAGE) => {
  //BASE CASE -> when not specified
  if (typeof alert !== "undefined") {
    //alert(error.message);
    alert("400 error");
  }
};
const defaultCallback401 = (error, language = DEFAULT_LANGUAGE) => {
  //BASE CASE -> when not specified
  if (typeof redirect !== "undefined") {
    alert("401 error");
  }
};
const defaultCallback403 = (error, language = DEFAULT_LANGUAGE) => {
  //BASE CASE -> when not specified
  if (typeof redirect !== "undefined") {
    alert("403 error");
  }
};
const defaultCallback404 = (error, language = DEFAULT_LANGUAGE) => {
  //BASE CASE -> when not specified
  if (typeof redirect !== "undefined") {
    alert("404 error");
  }
};
const defaultCallback500 = (error, language = DEFAULT_LANGUAGE) => {
  //BASE CASE -> when not specified
  if (typeof alert !== "undefined") {
    alert(error ? error : MESSAGE_GENERIC_ERROR[language]);
  }
};

const resultManipulation = (status = 500, data, configuration) => {
  switch (status) {
    case 200: {
      configuration.on200Callback(data);
      return createSuccessResponse(data);
    }
    case 400: {
      configuration.on400Callback(data);
      break;
    }
    case 401: {
      configuration.on401Callback(data);
      break;
    }
    case 403: {
      configuration.on403Callback(data);
      break;
    }
    case 404: {
      configuration.on404Callback(data);
      break;
    }
    case 500: {
      configuration.on500Callback(data);
      break;
    }
    default: {
      console.log(`${data.status} non gestito`);
      console.error("Error: ", data.toString());
      configuration.error(data);
    }
  }

  return createErrorResponse(data);
};

/**
 *
 * @params {*}
 * - url: url requested, default: null,
 * - method: http method to use - default: GET,
 * - language: language to use for generic error message - DEFAULT: en,
 * - headers: custom Headers, default: {}
 * - params: URL parameters, default: {}
 * - data: Body parameters (used in POST ecc.), default: {}
 * - on200Callback: callback to use on response with status 200, default: inside the package ,
 * - on400Callback: callback to use on response with status 400, default: inside the package ,
 * - on401Callback: callback to use on response with status 401, default: inside the package ,
 * - on403Callback: callback to use on response with status 403, default: inside the package ,
 * - on404Callback: callback to use on response with status 404, default: inside the package ,
 * - on500Callback: callback to use on response with status 500 and in all the errors occurred, default: inside the package ,
 * @returns
 * An object with this structure:
 * - status: http status code;
 * - messageStatus: on success 'OK' otherwise 'KO';
 * - message: string used to describe the case occured;
 * - data: data received by the api;
 */
export const request = async function ({
  url = null,
  method = ALLOWED_METHODS.GET,
  language = DEFAULT_LANGUAGE,
  headers = {}, // Custom Headers
  params = {}, // URL parameters
  data = {}, //Body parameters
  on200Callback = null,
  on400Callback = null,
  on401Callback = null,
  on403Callback = null,
  on404Callback = null,
  on500Callback = null,
}) {
  //URL not specified
  if (!url || url === "") {
    return createErrorResponse({}, `URL not specified`);
  }

  //Format method
  method = typeof method === "string" ? method.toUpperCase() : "";

  //Method not allowed
  if (!(method || isIncludedInArray(Object.keys(ALLOWED_METHODS), method))) {
    return createErrorResponse({}, `${method.toUpperCase()} not allowed`);
  }

  //Init params to send
  const configuration = {
    on200Callback: on200Callback ? on200Callback : defaultCallback200,
    on400Callback: on400Callback ? on400Callback : defaultCallback400,
    on401Callback: on401Callback ? on401Callback : defaultCallback401,
    on403Callback: on403Callback ? on403Callback : defaultCallback403,
    on404Callback: on404Callback ? on404Callback : defaultCallback404,
    on500Callback: on500Callback ? on500Callback : defaultCallback500,
    error: on500Callback ? on500Callback : defaultCallback500,
  };

  const httpConfiguration = {
    method,
    params,
    url,
    headers,
  };

  if (method !== ALLOWED_METHODS.GET) {
    httpConfiguration.data = data;
  }

  //Making the request
  return await axios(httpConfiguration)
    .then((data) => {
      if (data && data.status) {
        return resultManipulation(data.status, data, configuration);
      }
      return resultManipulation(500, null, configuration);
    })
    .catch((error) => {
      const status = error && error.response && error.response.status ? error.response.status : 500;
      const data = error && error.response ? error.response : null;
      //configuration.error(data);
      return resultManipulation(status, data, configuration);
    });
};
